import { useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEY_USER_PROFILE_DATA } from '@montugroup/circuit-shared/hooks/user/useGetUserProfile';
import useUser from '@montugroup/circuit-shared/hooks/user/useUser';
import type { IUserProfileResponse } from '@montugroup/circuit-shared/types/user';

export type Customer = {
  id: number;
  code: string;
  isDischarged: boolean;
  isExternal: boolean;
  isConcession: boolean;
  email: string;
  phone: string;
  shippingAddress: {
    address: string;
    phone: string;
    zipCode: string;
    city: string;
    countryId: number;
    stateId: number;
  };

  // TODO: Add more to the Customer type where needed, should be the source of truth for customer data
};

const useCustomer = () => {
  const queryClient = useQueryClient();
  const { isPatient } = useUser();

  return useQuery<Customer | null>({
    queryKey: ['customer'],
    // TODO: Remove the enabled check as all users are patient in patient-portal
    enabled: isPatient,
    queryFn: async () => {
      const userProfileData = (await queryClient.fetchQuery({
        queryKey: [QUERY_KEY_USER_PROFILE_DATA],
        // HACK: A small staleTime is only required to share the userProfileData queryCache data from useUser to useCustomer before they become dependant on seperate API requests
        staleTime: 1000,
      })) as IUserProfileResponse;

      return {
        id: userProfileData.patient.id,
        code: userProfileData.patient.patient_code,
        isDischarged: !!userProfileData.patient.is_discharge,
        isExternal: userProfileData.patient.is_external,
        isConcession: !!userProfileData.concession_status?.valid,
        email: userProfileData.user.email,
        phone: userProfileData.user.phone,

        shippingAddress: {
          address: userProfileData.user.address,
          phone: userProfileData.user.phone,
          zipCode: userProfileData.user.zip_code,
          city: userProfileData.user.city,
          countryId: userProfileData.user.country_id,
          stateId: userProfileData.user.state_id,
        },
      };
    },
  });
};

export default useCustomer;
